import { connect } from 'react-redux';
import orderModule from 'app/store/order';
import SittingPlan from './SittingPlan.component';
import sessionsTicketsModule from 'app/store/sessionsTickets';
import LayoutModule from 'app/store/layout';

const concatSeatsLegend = rawData =>
  rawData && rawData.length
    ? rawData.reduce((result, arr) => result.concat(arr.areaCategories), [])
    : rawData;

const { orderRequest } = orderModule.actions;
const { createToast } = LayoutModule.actions;
const { requestSesseionsSeatPlan, orderSessionRequest } = sessionsTicketsModule.actions;

const mapDispatchToProps = {
  orderRequest,
  seatPlanRequest: requestSesseionsSeatPlan,
  orderSessionRequest: orderSessionRequest,
  notify: createToast,
};

const mapStateToProps = ({
  order,
  sessions: {
    session: {
      session: { sessionId, cinemaId }
    }
  },
  seatPlan: { plan, legend },
}) => ({
  seatPlan: plan,
  order,
  seatsLegend: concatSeatsLegend(legend),
  sessionId,
  cinemaId
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SittingPlan);
